import VerifyMailSuccess from '../components/Auth/VerifyMailSuccess';

export default function VerifyMail() {
  return <VerifyMailSuccess />;
}
